import * as Yup from 'yup';
export var LevelValidation = Yup.object().shape({
    name: Yup.string().min(1).max(30).required(),
    description: Yup.string().min(1).max(225).required(),
});
